import { xylemStorage } from "@grindex-client/components/SessionStorage/xylemStorage";
import { videoRenderer } from "@grindex-common/helpers/videoRenderer";
import $ from "jquery";
import "./helpers/lazyLoadBg";
import { runModules } from "./moduleRunner";

const setupGlobals = function () {
	$(".js-back-top").click(function (e) {
		e.preventDefault();
		$("html,body").animate(
			{
				scrollTop: 0,
			},
			700,
		);
	});

	// $.blockUI.defaults.css = {};
	// $.blockUI.defaults.overlayCSS.opacity = 0;

	const XYL = {};
	const globals = {};

	XYL.views = XYL.views || {};
	XYL.models = XYL.models || {};
	XYL.collections = XYL.collections || {};
	XYL.config = XYL.config || {};
	XYL.config.cookies = XYL.config.cookies || {};

	globals.sysVars = {
		// A listing of DOM objects that specifically need to be "buried" (lowered z-index) when the modal pops up
		arrObjsToBury: [
			...document.querySelectorAll(".persistent-header"),
			...document.querySelectorAll(".fixed-header"),
			...document.querySelectorAll(".desktop.search > *"),
		],
	};
	window.XYL = XYL;
	window.globals = globals;
};

setupGlobals();

/**
 * Loader
 * @returns {{init: Function, viewInstances: any[]}}
 */
const Loader = function () {
	var views = [];
	/**
	 * Initializer
	 */
	const init = function () {
		videoRenderer.init();

		identifyBrandCardCarousels();

		initSessionStorage();
	};

	function initSessionStorage() {
		for (const selector of xylemStorage.applicationDetail.triggerSelectors) {
			$(selector).addClass("js-ss-trigger");
		}

		for (const selector of xylemStorage.applicationDetail.unTriggerSelectors) {
			$(selector).addClass("js-ss-untrigger");
		}
	}

	function identifyBrandCardCarousels() {
		const brandList = $(".component-cardCarouselBlock ul.cardSlider:has(.card-brand)");
		brandList.addClass("isBrandCarousel").find("li").addClass("isBrand");
	}

	// Public
	return {
		init: init,
		viewInstances: views,
	};
};

export function createGrindexApp({ modules }) {
	const loader = Loader();
	loader.init();
	runModules(modules);
}
